module.exports = __webpack_public_path__ + "img/D.c1031935.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/D.jpg
// module id = WV21
// module chunks = 1